import ApisMethods from './apisMethods'
import paymentMethod from './paymentMethod'
import General from './SettingGeneral'

const OnboardingApi = {
  getLunch: (callback: any, setIsLoading?: any) => {
    ApisMethods().get(`/vendor/settings/lunch`, callback, setIsLoading)
  },
  getGeneral: (callback: any, setIsLoading?: any) => {
    General.get(callback, setIsLoading)
  },
  saveGeneral: (data: any, callback: any, setIsLoading?: any) => {
    General.put(data, callback, setIsLoading)
  },
  getShipping: (callback: any, setIsLoading?: any) => {
    General.getShapping(callback, setIsLoading)
  },
  saveShipping: (data: any, callback: any, setIsLoading?: any) => {
    General.editShapping(data, callback, setIsLoading)
  },
  getRefund: (callback: any, setIsLoading?: any) => {
    General.GetOrder(callback, setIsLoading)
  },
  saveRefund: (data: any, callback: any, setIsLoading?: any) => {
    General.EditOrder(data, callback, setIsLoading)
  },
  getPaymentMethods: (callback: any, setIsLoading?: any) => {
    paymentMethod.get(callback, setIsLoading)
  },
  complete: (callback: any, setIsLoading?: any) => {
    ApisMethods().post(`/vendor/settings/onboarding/complete`, {}, callback, setIsLoading)
  },
}

export default OnboardingApi
